{
  "namespaceUris": [
    "http://opcfoundation.org/UA/",
    "http://opcfoundation.org/UA/MachineTool/",
    "http://opcfoundation.org/UA/Machinery/",
    "http://opcfoundation.org/UA/DI/",
    "http://opcfoundation.org/UA/IA/",
    "http://opcfoundation.org/UA/Machinery/Result/",
    "http://opcfoundation.org/UA/GMS/"
  ],
  "header": {
    "nameVariable": {
      "variablePath": "3:Identification.3:ProductInstanceUri",
      "dataType": "String"
    },
    "modelVariable": {
      "variablePath": "3:Identification.3:Model",
      "dataType": "LocalizedText"
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "gms.jpg"
    }
  },
  "stacklight": {
    "lampPlaceholders": [
      {
        "variablePath": "1:Monitoring.1:Stacklight",
        "reference": "49",
        "type": "4:1006"
      }
    ],
    "signalVariable": {
      "variablePath": "4:SignalOn",
      "dataType": "Boolean"
    },
    "signalOnValue": "true",
    "signalOffValue": "false",
    "colorVariable": {
      "variablePath": "4:SignalColor",
      "dataType": "SignalColor"
    },
    "colorValues": {
      "0": "off",
      "1": "red",
      "2": "green",
      "3": "blue",
      "4": "yellow",
      "5": "purple",
      "6": "cyan",
      "7": "white"
    },
    "sortingVariable": {
      "variablePath": "NumberInList",
      "dataType": "UInteger"
    }
  },
  "timeline": {
    "variable": {
      "variablePath": "1:Production.1:ActiveProgram.1:State.0:CurrentState.Number",
      "dataType": "UInt32"
    },
    "colorValues": {
      "0": "#eaeaea",
      "1": "#00b20e",
      "2": "#17a2b8",
      "3": "#ffc107",
      "4": "#ff4136"
    }
  },
  "sections": [
    {
      "id": "a095125dd5f0f09615c88d28501aca28",
      "title": "Identification",
      "rows": [
        {
          "id": "aa81bb687d91d66362f420beee140693",
          "elements": [
            {
              "id": "e053cabd9cedd5355d4998de961abdd2",
              "type": 0,
              "label": "Manufacturer",
              "valueVariable": {
                "variablePath": "3:Identification.3:Manufacturer",
                "dataType": "LocalizedText"
              }
            },
            {
              "id": "c8426a68a529932b30d76b765f383448",
              "type": 0,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "variablePath": "3:Identification.3:ProductInstanceUri",
                "dataType": "String"
              }
            },
            {
              "id": "390ac0b6f2d697b6cdcae653d7bc7867",
              "type": 0,
              "label": "Serial Number",
              "valueVariable": {
                "variablePath": "3:Identification.3:SerialNumber",
                "dataType": "String"
              }
            },
            {
              "id": "f9f8001cbc0e51437447aae03a6d1317",
              "type": 0,
              "label": "Software Revision",
              "valueVariable": {
                "variablePath": "3:Identification.3:SoftwareRevision",
                "dataType": "String"
              }
            },
            {
              "id": "5a3ac8b25c75972ebb886e3a88ee897e",
              "type": 0,
              "label": "Build Year",
              "valueVariable": {
                "variablePath": "3:Identification.2:YearOfConstruction",
                "dataType": "UInt16"
              }
            },
            {
              "id": "bb3c4e3e4b711214e29b2d89b92dbb45",
              "type": 0,
              "label": "Device Class",
              "valueVariable": {
                "variablePath": "3:Identification.3:DeviceClass",
                "dataType": "String"
              }
            },
            {
              "id": "caa7c510f43fe62277ff0d6d56eb5620",
              "type": 0,
              "label": "Location",
              "valueVariable": {
                "variablePath": "3:Identification.2:Location",
                "dataType": "String"
              }
            },
            {
              "id": "92fcfc1973029f3a8bb507891f3791b0",
              "type": 0,
              "label": "Model",
              "valueVariable": {
                "variablePath": "3:Identification.3:Model",
                "dataType": "LocalizedText"
              }
            },
            {
              "id": "59d343a5e30e62f78f301ebdc86b91c8",
              "type": 0,
              "label": "Product Code",
              "valueVariable": {
                "variablePath": "3:Identification.3:ProductCode",
                "dataType": "String"
              }
            }
          ]
        }
      ]
    },
    {
      "id": "bf19594d62f4d4cf2da654edc3cd4e81",
      "title": "Tools",
      "rows": [
        {
          "id": "d57a336efdfe15c2eda195cd71db60e8",
          "placeholders": [
            {
              "variablePath": "1:Equipment.1:Tools",
              "reference": "47",
              "type": "1:50"
            }
          ],
          "title": "Tools",
          "titleVariable": {
            "variablePath": "1:Name",
            "dataType": "String"
          },
          "elements": [
            {
              "id": "ad723e95efed695f422f27443ff9775d",
              "type": 0,
              "label": "Control Identifier Interpretation",
              "valueVariable": {
                "variablePath": "1:ControlIdentifierInterpretation",
                "dataType": "Enum",
                "enumValues": {
                  "0": "NumberBased",
                  "1": "GroupBased",
                  "2": "Other"
                }
              }
            },
            {
              "id": "3a181e8e9a93a112eb6b5eb77f97f73d",
              "type": 0,
              "label": "Identifier",
              "valueVariable": {
                "variablePath": "1:ControlIdentifier1",
                "dataType": "UInt32"
              }
            },
            {
              "id": "c3a86daf031d7160aa11da90e365d188",
              "type": 0,
              "label": "Name",
              "valueVariable": {
                "variablePath": "1:Name",
                "dataType": "String"
              }
            },
            {
              "id": "a78093d6284952ad19b147e25e948bec",
              "type": 2,
              "valueVariable": {
                "variablePath": "1:Locked",
                "dataType": "Boolean"
              },
              "badgeValues": [
                {
                  "backgroundColor": "#DC3545",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "Locked"
                },
                {
                  "backgroundColor": "#198754",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "Active"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "dd849f15e90fb9736c710eec966c5bca",
      "title": "Active Program",
      "rows": [
        {
          "id": "693c5ca89bf7dbaa4b2673f6c0f7bcb9",
          "elements": [
            {
              "id": "9756e5cd54b07c68fe98b7ba99889d30",
              "type": 0,
              "label": "Name",
              "valueVariable": {
                "variablePath": "1:Production.1:ActiveProgram.1:Name",
                "dataType": "String"
              }
            },
            {
              "id": "8dfdd987acdd92afa167a98ddafe5b7e",
              "type": 0,
              "label": "State Id",
              "valueVariable": {
                "variablePath": "1:Production.1:ActiveProgram.1:State.CurrentState.Id",
                "property": "Id",
                "dataType": "Int"
              }
            },
            {
              "id": "3a64fad4f258fa373ab5b2071901d22b",
              "type": 2,
              "valueVariable": {
                "variablePath": "1:Production.1:ActiveProgram.1:State.CurrentState",
                "dataType": "LocalizedText"
              },
              "badgeValues": [
                {
                  "backgroundColor": "#eaeaea",
                  "textColor": "#000000",
                  "value": "Initializing"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "Running"
                },
                {
                  "backgroundColor": "#17a2b8",
                  "textColor": "#ffffff",
                  "value": "Ended"
                },
                {
                  "backgroundColor": "#ffc107",
                  "textColor": "#000000",
                  "value": "Interrupted"
                },
                {
                  "backgroundColor": "#ff4136",
                  "textColor": "#ffffff",
                  "value": "Aborted"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "3c5336a1da1de83351a620cbf89e859f",
      "title": "Monitoring",
      "rows": [
        {
          "id": "10faadf0518ab62c7a8779ce52d05aa7",
          "title": "Geometrical Measuring System",
          "elements": [
            {
              "id": "ff406d558402c9c5ce7cdaf470a19fd8",
              "type": 0,
              "label": "Operation Mode",
              "valueVariable": {
                "variablePath": "1:Monitoring.1:MachineTool.1:OperationMode",
                "dataType": "Enum",
                "enumValues": {
                  "0": "Manual",
                  "1": "Automatic",
                  "2": "Setup",
                  "3": "AutoWithManualIntervention",
                  "4": "Service",
                  "5": "Other"
                }
              }
            },
            {
              "id": "fc1883335d98c7cfeb7f82b45f89a14b",
              "type": 0,
              "label": "Power On Duration",
              "valueVariable": {
                "variablePath": "1:Monitoring.1:MachineTool.1:PowerOnDuration",
                "dataType": "UInt32"
              }
            },
            {
              "id": "bb7e79a6e02999a0ec7043f7ffa012a8",
              "type": 1,
              "label": "Feed Override",
              "valueVariable": {
                "variablePath": "1:Monitoring.1:MachineTool.1:FeedOverride",
                "dataType": "Double",
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "id": "3c68a78b241749f874ee0abe254df0f5",
          "placeholders": [
            {
              "variablePath": "1:Monitoring",
              "reference": "47",
              "type": "1:16"
            }
          ],
          "title": "Channels",
          "titleVariable": {
            "variablePath": "1:Name",
            "dataType": "String"
          },
          "elements": [
            {
              "id": "595600c629185b88e1c96140899891c8",
              "type": 0,
              "label": "Channel Mode",
              "valueVariable": {
                "variablePath": "1:ChannelMode",
                "dataType": "Enum",
                "enumValues": {
                  "0": "Automatic",
                  "1": "MdaMdi",
                  "2": "JogManual",
                  "3": "JogIncrement",
                  "4": "TeachingHandle",
                  "5": "Remote",
                  "6": "Reference",
                  "7": "Other"
                }
              }
            },
            {
              "id": "13335faaf134f516b6f58d687c5cda8c",
              "type": 0,
              "label": "Channel State",
              "valueVariable": {
                "variablePath": "1:ChannelState",
                "dataType": "Enum",
                "enumValues": {
                  "0": "Active",
                  "1": "Interrupted",
                  "2": "Reset"
                }
              }
            },
            {
              "id": "396d55bd5767411d87b38eeacb090b3b",
              "type": 0,
              "label": "Minimal Override",
              "valueVariable": {
                "variablePath": "1:FeedOverride.EURange",
                "property": "Low",
                "dataType": "Double"
              }
            },
            {
              "id": "0db130f14d3a7c3ef3ae09a84450737d",
              "type": 0,
              "label": "Maximal Override",
              "valueVariable": {
                "variablePath": "1:FeedOverride.EURange",
                "property": "High",
                "dataType": "Double"
              }
            },
            {
              "id": "035f2d87316b52e4f3625280c4bfc379",
              "type": 1,
              "label": "Feed Override",
              "valueVariable": {
                "variablePath": "1:FeedOverride",
                "dataType": "Double",
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "id": "6f475c3e6a40568c2a00914b3eb003a2",
          "placeholders": [
            {
              "variablePath": "1:Monitoring",
              "reference": "47",
              "type": "1:22"
            }
          ],
          "title": "Spindles",
          "titleVariable": {
            "variablePath": "1:Name",
            "dataType": "String"
          },
          "elements": [
            {
              "id": "aaf7d739bbf783e5062bd646461346b8",
              "type": 0,
              "label": "State (is rotating)",
              "valueVariable": {
                "variablePath": "1:IsRotating",
                "dataType": "Boolean"
              }
            },
            {
              "id": "dcb98a56a138a506dbde45252fe373df",
              "type": 0,
              "label": "State (is used as axis)",
              "valueVariable": {
                "variablePath": "1:IsUsedAsAxis",
                "dataType": "Boolean"
              }
            },
            {
              "id": "b2090d274f75e0c1943c2eba786d6ae7",
              "type": 1,
              "label": "Override",
              "valueVariable": {
                "variablePath": "1:Override",
                "dataType": "Double",
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        }
      ]
    },
    {
      "id": "f965b9eb-8692-428a-9f71-c89e7bf983af",
      "isPlaceholder": true,
      "title": "Results",
      "rows": [
        {
          "id": "3c68a78b241749f874ee0abe254df0f5",
          "placeholders": [
            {
              "variablePath": "6:ResultManagement.5:Results",
              "reference": "47",
              "type": "5:2001"
            }
          ],
          "title": "Results",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": true,
              "label": "ID",
              "showAsLink": false,
              "valueVariable": {
                "id": "76eefd14204a41a0900f499c35438c04",
                "variablePath": ".",
                "field": "ResultMetaData.ResultId",
                "dataType": "Structure",
                "valueRank": -1
              },
              "id": "48b5f7e6-667a-4414-a347-00b4e6713d73"
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#6c7580",
                  "textColor": "#ffffff",
                  "value": "0",
                  "label": "Undefined"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "1",
                  "label": "Completed"
                },
                {
                  "backgroundColor": "#ffc107",
                  "textColor": "#000000",
                  "value": "2",
                  "label": "Processing"
                },
                {
                  "backgroundColor": "#dc3545",
                  "textColor": "#ffffff",
                  "value": "3",
                  "label": "Aborted"
                },
                {
                  "backgroundColor": "#dc3545",
                  "textColor": "#ffffff",
                  "value": "4",
                  "label": "Failed"
                }
              ],
              "label": "Status",
              "valueVariable": {
                "id": "91a25b87-c507-4c40-be2e-976e88c24937",
                "variablePath": ".",
                "dataType": "Structure",
                "field": "ResultMetaData.ResultState",
                "valueRank": -1,
                "hasUnit": false,
                "hasRange": false
              },
              "id": "fee4af36-1813-445a-9c9d-a2e47bfdbaf5"
            },
            {
              "type": 4,
              "isPlaceholder": false,
              "label": "Files",
              "showAsLink": true,
              "valueVariable": {
                "id": "6aae8b1f44f64764b5019f0941553eb3",
                "variablePath": ".",
                "field": "ResultMetaData.ResultUri",
                "dataType": "Structure",
                "valueRank": 1
              },
              "id": "aa694253-1c67-44d7-81d0-182c65e7cf6d"
            },
            {
              "type": 4,
              "isPlaceholder": false,
              "label": "Formats",
              "showAsLink": false,
              "valueVariable": {
                "id": "7d45f4e09fb146c0b361ca6d48728398",
                "variablePath": ".",
                "dataType": "Structure",
                "field": "ResultMetaData.FileFormat",
                "valueRank": 1
              },
              "id": "3d307c30-6424-4ad5-95be-78d5cab68fbf"
            }
          ]
        },
        {
          "id": "0f4de3a8-bc0c-41ae-829d-bc25ea299df0",
          "isPlaceholder": false,
          "elements": [
            {
              "type": 3,
              "isPlaceholder": true,
              "label": "Correction (Deviation) List",
              "columns": [
                {
                  "label": "Id",
                  "valueVariable": {
                    "id": "be7da56cf34b40599e3c7bd54fb08307",
                    "variablePath": "6:Identifier",
                    "dataType": "String",
                    "valueRank": -1
                  }
                },
                {
                  "label": "Characteristic Id",
                  "valueVariable": {
                    "id": "7301600afe25429191faeb5b6a28d473",
                    "variablePath": "6:CharacteristicIdentifier",
                    "dataType": "String",
                    "valueRank": -1
                  }
                },
                {
                  "label": "Correction abs",
                  "valueVariable": {
                    "id": "bab7f516c4024f83b99c74c2c838ef5b",
                    "variablePath": "6:CorrectionValueAbsolute",
                    "dataType": "Double",
                    "valueRank": -1,
                    "hasUnit": true,
                    "hasRange": false
                  }
                },
                {
                  "label": "Upper Limit",
                  "valueVariable": {
                    "id": "b185a9ac713942698e4a07280bb7c2b5",
                    "variablePath": "6:UpperControlLimit",
                    "dataType": "Double",
                    "valueRank": -1,
                    "hasUnit": true,
                    "hasRange": false
                  }
                },
                {
                  "label": "Lower Limit",
                  "valueVariable": {
                    "id": "f3061e1d-69f64dbfb6922540076499bd",
                    "variablePath": "6:LowerControlLimit",
                    "dataType": "Double",
                    "valueRank": -1,
                    "hasUnit": true,
                    "hasRange": false
                  }
                }
              ],
              "rowPlaceholders": [
                {
                  "variablePath": "6:ResultManagement.6:CorrectionsFolder",
                  "reference": "47",
                  "type": "6:1005"
                }
              ],
              "id": "a87e6619-539e-4acc-9703-d031f562fe10"
            }
          ]
        }
      ]
    },
    {
      "id": "55f92d0d-fc28-4447-bfbf-6584a8e579a9",
      "isPlaceholder": false,
      "title": "Calibration Information",
      "rows": [
        {
          "id": "8f12fc55-6b59-4cd2-b0e7-1385c67bb084",
          "placeholders": [
            {
              "variablePath": "2:Notification.2:Prognoses",
              "reference": "47",
              "type": "2:1019"
            }
          ],
          "elements": [
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "yes"
                },
                {
                  "backgroundColor": "#dc3545",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "no"
                }
              ],
              "label": "Calibrated",
              "valueVariable": {
                "id": "102acd8f5b8649cd951b708618b6f2f2",
                "variablePath": "6:Calibrated",
                "dataType": "Boolean",
                "valueRank": -1
              },
              "id": "93b97822-d03d-42d3-b142-863bf3a82b68"
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Calibration Date",
              "showAsLink": false,
              "valueVariable": {
                "id": "41f096bf184947a9b82b024fc322a63f",
                "variablePath": "6:DateOfCalibration",
                "dataType": "UtcTime",
                "valueRank": -1
              },
              "id": "93c226b5-452c-48d7-8206-a25fe704c0a0"
            },
            {
              "type": 4,
              "isPlaceholder": false,
              "label": "Files",
              "showAsLink": true,
              "valueVariable": {
                "id": "9c66fca7da2c4317b5c2c5c9e6c92177",
                "variablePath": "6:CalibrationCertificate",
                "dataType": "String",
                "valueRank": 1
              },
              "id": "cfcbad7d-79f9-4284-b1fc-13078c03b571"
            }
          ]
        }
      ]
    }
  ]
}
